import { render, staticRenderFns } from "./Comprehensive.vue?vue&type=template&id=5c2ba75f&scoped=true"
import script from "./Comprehensive.vue?vue&type=script&lang=js"
export * from "./Comprehensive.vue?vue&type=script&lang=js"
import style0 from "./Comprehensive.vue?vue&type=style&index=0&id=5c2ba75f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ba75f",
  null
  
)

export default component.exports